import {
  TAssetTreeNode,
} from '@/api/asset.ts';
import {
  components,
} from '@/generated/qmulus/openapi.ts';

export enum EHierarchy {
  ROOT = -10,
  COMPANY = 0,
  LOCATION = 10,
  AREA = 13,
  AUTOMAT = 15,
  EQUIPMENT_GROUP = 17,
  EQUIPMENT = 20,
  CHAMBER = 30,
  COMPONENT = 40,
}

export const HierarchyMap: Record<components['schemas']['AssetHierarchyLevel'], keyof typeof EHierarchy> = {
  '-10': 'ROOT',
  '0': 'COMPANY',
  '10': 'LOCATION',
  '13': 'AREA',
  '17': 'EQUIPMENT_GROUP',
  '15': 'AUTOMAT',
  '20': 'EQUIPMENT',
  '30': 'CHAMBER',
  '40': 'COMPONENT',
};

export const ALL_ASSET_HIERARCHY_LEVELS: EHierarchy[] = [
  // The roo level is not accessible to the user, thus we omit it here
  EHierarchy.COMPANY,
  EHierarchy.LOCATION,
  EHierarchy.AREA,
  EHierarchy.AUTOMAT,
  EHierarchy.EQUIPMENT,
  EHierarchy.EQUIPMENT_GROUP,
  EHierarchy.CHAMBER,
  EHierarchy.COMPONENT,
];

export const LICENSED_ASSET_HIERARCHY_LEVELS: Set<EHierarchy> = new Set([
  EHierarchy.COMPANY,
  EHierarchy.LOCATION,
  EHierarchy.AUTOMAT,
  EHierarchy.EQUIPMENT,
]);

export type TFlattenedAssetTreeNode = TAssetTreeNode & {
  path: TFlattenedAssetTreeNode[],
};

export type TAssetOverview = TFlattenedAssetTreeNode & {
  ancestors: Map<EHierarchy, number | undefined>,
};
